<!-- Created by henian.xu on 2020/4/15. -->

<template>
    <RemoteSelect
        class="experience-picker"
        remote="/sv/examPaperExperience/data"
        filterable
        multiple
        :props="{name:'examName'}"
        disabled-cache
        v-model="model"
    />
</template>

<script>
export default {
    name: 'ExperiencePicker',
    data() {
        return {};
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
};
</script>

<style lang="scss">
.experience-picker {
}
</style>
